import { Font } from '@react-pdf/renderer';
import { useEffect } from 'react';
import useCSSVariables from './useCSSVariables';

const usePDFFonts = () => {
    const cssVariables = useCSSVariables();
    const fontFamily = cssVariables['--font-sans'];

    useEffect(() => {
        if (fontFamily) {
            if (fontFamily === 'Poppins') {
                Font.register({
                    family: fontFamily,
                    fonts: [
                        { src: `/fonts/Poppins/Poppins-Regular.ttf`, fontWeight: 400 },
                        { src: `/fonts/Poppins/Poppins-Medium.ttf`, fontWeight: 500 },
                        { src: `/fonts/Poppins/Poppins-SemiBold.ttf`, fontWeight: 600 },
                        { src: `/fonts/Poppins/Poppins-Bold.ttf`, fontWeight: 700 }
                    ]
                });
            }
            if (fontFamily === 'Space Grotesk') {
                Font.register({
                    family: fontFamily,
                    fonts: [
                        { src: `/fonts/SpaceGrotesk/SpaceGrotesk-Regular.ttf`, fontWeight: 400 },
                        { src: `/fonts/SpaceGrotesk/SpaceGrotesk-Medium.ttf`, fontWeight: 500 },
                        { src: `/fonts/SpaceGrotesk/SpaceGrotesk-SemiBold.ttf`, fontWeight: 600 },
                        { src: `/fonts/SpaceGrotesk/SpaceGrotesk-Bold.ttf`, fontWeight: 700 }
                    ]
                });
            }
            if (fontFamily === 'Fraunces') {
                Font.register({
                    family: fontFamily,
                    fonts: [
                        { src: `/fonts/Fraunces/Fraunces-Regular.ttf`, fontWeight: 400 },
                        { src: `/fonts/Fraunces/Fraunces-SemiBold.ttf`, fontWeight: 600 },
                        { src: `/fonts/Fraunces/Fraunces-Bold.ttf`, fontWeight: 700 }
                    ]
                });
            }
            if (fontFamily === 'Inter') {
                Font.register({
                    family: fontFamily,
                    fonts: [
                        { src: `/fonts/Inter/Inter-Regular.ttf`, fontWeight: 400 },
                        { src: `/fonts/Inter/Inter-Medium.ttf`, fontWeight: 500 },
                        { src: `/fonts/Inter/Inter-SemiBold.ttf`, fontWeight: 600 },
                        { src: `/fonts/Inter/Inter-Bold.ttf`, fontWeight: 700 }
                    ]
                });
            }
        }
    }, [fontFamily]);
};

export default usePDFFonts;
